// store.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        operadorId: false,
        operador: window.sessionStorage.getItem("operador")
            ? window.sessionStorage.getItem("operador")
            : 0,
        isAdmin: window.sessionStorage.getItem("permisos") && JSON.parse(sessionStorage.getItem("permisos"))
            ? JSON.parse(sessionStorage.getItem("permisos")).includes("FO_LIQ_ADMIN")
            : false,
        isOperador: window.sessionStorage.getItem("permisos") && JSON.parse(sessionStorage.getItem("permisos"))
            ? JSON.parse(sessionStorage.getItem("permisos")).includes("FO_LIQ")
            : false,
        permisos: window.sessionStorage.getItem('permisos') && JSON.parse(sessionStorage.getItem("permisos")) ? JSON.parse(window.sessionStorage.getItem('permisos')).split(',') : [],
        cliente: window.sessionStorage.getItem('cliente') && JSON.parse(sessionStorage.getItem("cliente"))
            ? JSON.parse(window.sessionStorage.getItem('cliente')).codigo : '',
        farmacia: window.sessionStorage.getItem('cliente') 
            ? JSON.parse(window.sessionStorage.getItem('cliente')) : '',
    },
    mutations: {
        setIsAdmin(state, newValue) {
            state.isAdmin = newValue;
        },
        setOperador(state, newValue) {
            state.operador = newValue;
        },
    },
    actions: {
        // You can add actions for asynchronous operations
    },
    getters: {
        // You can add getters to compute derived state
    },
});